import { Location } from '@/modules/content-blocks/interfaces';
import { Address } from '@future-harry/nxt-vue-library';

export const createDefaultLocation = (): Location => ({
   id: crypto.randomUUID(),
   title: {},
   address: { city: {} } as Address,
   email: null,
   phone: null,
});

export const formatAddress = (address: Address | null): string => {
   if (!address) return '';

   const parts: string[] = [];

   if (address.street) {
      const streetPart = `${address.street} ${address.house_number} ${address.box || ''}`.trim();
      parts.push(streetPart);
   }

   if (address.city?.name || address.city?.postal_code) {
      const cityPart = `${address.city.postal_code} ${address.city.name}`;
      parts.push(cityPart);
   }

   if (address.city?.country?.name) {
      parts.push(address.city.country.name);
   }

   return parts.join(', ');
};
